/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScreeningsRunRequestDto } from '../../models/screenings-run-request-dto';
import { ScreeningsRunResponseDto } from '../../models/screenings-run-response-dto';

export interface Run$Params {
      body: ScreeningsRunRequestDto
}

export function run(http: HttpClient, rootUrl: string, params: Run$Params, context?: HttpContext): Observable<StrictHttpResponse<ScreeningsRunResponseDto>> {
  const rb = new RequestBuilder(rootUrl, run.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ScreeningsRunResponseDto>;
    })
  );
}

run.PATH = '/screenings/run';
